import styled, {css} from 'styled-components';

export default styled.section`
	.customScrollbar {
		--item-size: 10rem;
		overflow-y: auto;
		max-height: calc(5 * var(--item-size));
		@media screen and (max-width: 1500px) {
			grid-template-columns: var(--custom-accordion-columns);
			--item-size: 5rem;
		}
	}
	.motif-card {
		border-radius: 4px;
		.motif-card-body {
			.table-header {
				background: var(--accordion-functional-expanded-bg-color);
			}
			.table-header,
			.table-row,
			.list-body-pagination {
				padding: 0 var(--gap);
			}
			.table-row {
				height: 5rem;
			}
			.userListItem {
				padding: 0;
			}
		}
	}
	.motif-card:hover {
		box-shadow: none !important;
		-webkit-box-shadow: none !important;
	}
	.list-body-pagination {
		.motif-pagination-select-wrapper {
			pointer-events: none !important;
			opacity: 0.4 !important;
		}
		background: var(--accordion-functional-expanded-bg-color);
		border-radius: 0 0 var(--border-radius) var(--border-radius);
		.motif-pagination .motif-pagination-count .motif-pagination-current-page {
			font-family: 'EYInterstate';
		}
	}
	.motif-icon {
		margin: 0;
		margin-right: 2px;
	}
	.table-row,
	.table-header {
		.custom-table-selector {
			display: flex;
			justify-content: center;
			align-items: center;
			transition: opacity 0.2s ease-in-out;
			opacity: ${({hasSelection}) => (hasSelection ? 1 : 0)};
			& > label {
				height: 1.6rem;
				width: 1.6rem;
				position: relative;
				& > * {
					position: absolute;
					top: 0;
					left: 0;
				}
				.motif-checkbox-custom {
					border-radius: 0.2rem;
				}
			}
		}
		&:hover {
			.custom-table-selector {
				opacity: 1;
			}
		}
		.motif-icon-button {
			opacity: 0;
			transition: opacity 0.2s ease-in-out;
			pointer-events: none;
		}
		&:hover {
			.motif-icon-button {
				opacity: 1;
				pointer-events: auto;
			}
		}
	}
`;
